import React from 'react';

export const UnemploymentPeriodInfo = () => (
  <>
    <p>De eerste 12 maanden wordt uitgekeerd zolang u werkloos bent,
      ook als het recht op een WW uitkering op basis van uw arbeidsverleden korter is.
    </p>
  </>
);
